import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function fmtUSD(n) {
  if (n == null || isNaN(n)) return "$0";
  return "$" + Number(n).toLocaleString("en-US", { maximumFractionDigits: 0 });
}

export function fmtDate(iso, opts = {}) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric", ...opts });
}

export function relativeTime(iso) {
  if (!iso) return "";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 86400 * 7) return `${Math.floor(diff / 86400)}d ago`;
  return fmtDate(iso);
}

export const COUNTRIES = [
  "Nigeria", "Ghana", "Kenya",
  "USA", "UK", "Canada", "Germany", "France", "Australia",
];

export const FLAGS = {
  Nigeria: "🇳🇬", Ghana: "🇬🇭", Kenya: "🇰🇪",
  USA: "🇺🇸", UK: "🇬🇧", Canada: "🇨🇦", Germany: "🇩🇪", France: "🇫🇷", Australia: "🇦🇺",
};

export function initials(name) {
  if (!name) return "?";
  return name.split(" ").map((p) => p[0]).join("").slice(0, 2).toUpperCase();
}
